import { ReactComponent as MustardLogo } from "assets/images/logo.svg";
import "./SelfCampaignBrandHeader.scss";

type SelfCampaignBrandHeaderProps = {
  withTopOffset?: boolean;
};

const SelfCampaignBrandHeader: React.FC<SelfCampaignBrandHeaderProps> = ({
  withTopOffset = true,
}) => {
  const rootClassName = [
    "self-campaign-brand-header",
    withTopOffset ? "self-campaign-brand-header--with-offset" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <header className={rootClassName}>
      <div className="self-campaign-brand-header__brand">
        <MustardLogo className="self-campaign-brand-header__logo" />
      </div>
    </header>
  );
};

export default SelfCampaignBrandHeader;
